import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * GET /api/listings/[id]/status param schema
 * Gets the current status of a listing
 */
export const GetStatusParamSchema = z.object({
  id: z.string().refine(val => !isNaN(parseInt(val, 10)), 'Invalid listing ID'),
});

/**
 * GET /api/listings/[id]/status response schema
 * Returns the listing status and seller's Stripe verification status
 */
export const GetStatusResponseSchema = z.union([
  z.object({
    // Status can be number, string (coerced), or null from database
    status: z.union([z.number(), z.string(), z.null()]),
    // Whether seller has verified Stripe Connect account (from USER_REMOTE_API + Stripe API)
    sellerVerified: z.boolean().optional(),
    // Present only when sellerVerified is false: no account, unfinished
    // onboarding, or a Stripe lookup that failed. Logged with the checkout
    // warning so the row says which.
    sellerUnverifiedReason: z.string().optional(),
    // External listing URL — if present, checkout should redirect here instead
    remote_url: z.string().nullable().optional(),
    // The signed-in viewer holds a live (not cancelled) order on this listing.
    // Checkout sends them to that order instead of calling their own sale
    // unavailable. Only ever true for a listing that is no longer buyable.
    viewerIsBuyer: z.boolean().optional(),
  }),
  z.object({
    error: z.string(),
  }),
]);

export type GetStatusParam = z.infer<typeof GetStatusParamSchema>;
export type GetStatusResponse = z.infer<typeof GetStatusResponseSchema>;
